import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface EmailGroup {
  groupName: string
  groupId: string
  enabled: boolean
}

export interface EmailGroupsListState {
  isLoading: boolean
  loadingError: string | null
  emailGroups: EmailGroup[] | null
  httpStatus: number | null
  totalCount: number
}

const initialState: EmailGroupsListState = {
  isLoading: true,
  loadingError: null,
  emailGroups: null,
  httpStatus: null,
  totalCount: 0
}

const emailGroupsListSlice = createSlice({
  name: 'emailGroupsList',
  initialState,
  reducers: {
    emailGroupsListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        emailGroups: null,
        totalCount: 0,
        httpStatus: 0
      }
    },
    emailGroupsListUpdateAction: (state, action: PayloadAction<{ data: EmailGroup[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        emailGroups: action.payload.data,
        totalCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    emailGroupsListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        emailGroups: null,
        totalCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  emailGroupsListLoadingAction,
  emailGroupsListUpdateAction,
  emailGroupsListErrorAction
} = emailGroupsListSlice.actions

export default emailGroupsListSlice.reducer
